<template>
  <div>
    <SearchBox class="mb-3" />

    <AppliedFilterBadges />

    <div class="row mb-3">
      <div class="col justify-content-between d-flex">
        <div>
          {{ totalCount }}
          <span v-if="totalCount === 1">{{ content.result }}</span>
          <span v-else>{{ content.results }}</span>
        </div>
        <div v-if="!isOrderByHidden" class="col text-right p-0 m-0">
          {{ content.orderBy }}:
          <div
            v-for="orderByOption in orderByOptions"
            :key="orderByOption.value"
            class="custom-control custom-radio custom-control-inline"
          >
            <input
              :id="orderByOption.value"
              v-model="orderByValue"
              class="custom-control-input"
              type="radio"
              name="inlineRadioOptions"
              :value="orderByOption.value"
              :aria-label="orderByOption.name"
              @change="onOrderByChange(orderByOption)"
            />
            <label class="custom-control-label" :for="orderByOption.value">
              {{ orderByOption.name }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <section class="results">
      <component
        :is="componentType(result)"
        v-for="result in results"
        :key="result.id"
        :result="result"
      />

      <nav class="justify-content-end mt-4">
        <BPagination
          v-if="pageNumber"
          :value="pageNumber"
          :total-rows="totalCount"
          :per-page="pageSize"
          :first-text="content.first"
          :prev-text="content.prev"
          :next-text="content.next"
          :last-text="content.last"
          align="center"
          class="flex-wrap"
          @change="onPageChange"
        />
      </nav>
    </section>
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue';
import { createNamespacedHelpers } from 'vuex';

import AppliedFilterBadges from './AppliedFilterBadges.vue';
import LiteratureResult from './results/LiteratureResult.vue';
import NewsPRResult from './results/NewsPRResult.vue';
import ProductResult from './results/ProductResult.vue';
import SearchResult from './results/SearchResult.vue';
import VideoResult from './results/VideoResult.vue';
import SearchBox from './SearchBox.vue';
import { action, mutation } from './store';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'SearchResults',

  components: {
    SearchBox,
    BPagination,
    SearchResult,
    AppliedFilterBadges,
    LiteratureResult,
    NewsPRResult,
    ProductResult,
    VideoResult,
  },

  data() {
    return {
      orderByValue: '',
    };
  },

  computed: {
    ...mapGetters([
      'results',
      'orderBy',
      'pageNumber',
      'pageSize',
      'totalCount',
      'content',
      'orderByOptions',
    ]),

    isOrderByHidden() {
      /* Order By is temporarily hidden to test if visitors use it */
      return true;
    },
  },

  watch: {
    orderBy: {
      immediate: true,
      handler(newValue, _) {
        this.orderByValue = newValue;
      },
    },
  },

  methods: {
    /**
     * @param {import('./store/state').SearchResult} result
     */
    componentType(result) {
      switch (result.pageType) {
        case 'hen05.productpage':
          return ProductResult;

        case 'hen05.literaturepage':
          return LiteratureResult;

        case 'hen05.newspage':
        case 'hen05.pressreleasepage':
          return NewsPRResult;

        case 'hen05.videopage':
          return VideoResult;

        default:
          return SearchResult;
      }
    },

    isSelected(orderByOption) {
      return this.$store.getters.orderBy === orderByOption.value;
    },

    async onOrderByChange(orderByOption) {
      this.$store.commit(mutation('SET_ORDER_BY'), orderByOption.value);

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    },

    async onPageChange(pageNumber) {
      this.$store.commit(mutation('SET_PAGE_NUMBER'), pageNumber);
      //const urlParams = new URLSearchParams(window.location.search);
      //urlParams.set('pageIndex', pageNumber);
      //window.history.pushState(pageNumber, '', `pageIndex=${pageNumber}`);
      //window.location.search = urlParams;

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    },
  },
};
</script>
